<h2 class="wwTitle mt-5">
  Setores deste totem
</h2>

<div class="setores">
  <mat-card *ngFor="let setor of setores">
    <mat-card-content style="display: flex; align-items: center; justify-content: space-between; margin: 0 5%;">
      <span>{{ setor.descricao }}</span>
      <mat-checkbox [(ngModel)]="setor.checked" (change)="onChangeCheckbox(setor.id)"></mat-checkbox>
    </mat-card-content>
  </mat-card>
</div>